<template>
  <el-container style="height:100vh;">
    <el-aside width="200px" style="background-color:#304156;">
      <el-menu
        :default-active="$route.path"
        router
        background-color="#304156"
        text-color="#fff"
        active-text-color="#409EFF"
      >
        <el-menu-item index="/sys-console-x9/user">用户管理</el-menu-item>
        <el-menu-item index="/sys-console-x9/content">内容管理</el-menu-item>
        <el-menu-item index="/sys-console-x9/log">业务日志</el-menu-item>
        <el-menu-item index="/sys-console-x9/feedback">用户留言</el-menu-item>
        <el-menu-item index="/sys-console-x9/admin-manage">管理员管理</el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header style="background:#fff;display:flex;justify-content:flex-end;align-items:center;padding:0 20px;border-bottom:1px solid #eee;">
        <span style="margin-right:16px;">管理员：{{ adminName }}</span>
        <el-button type="text" @click="logout">退出登录</el-button>
      </el-header>
      <el-main style="background:#f5f7fa;">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>
<script>
export default {
  data() {
    return {
      adminName: ''
    }
  },
    mounted() {
    try {
      const token = localStorage.getItem('admin_token')
      if (token) {
        // atob 只处理 Latin-1，中文需先 escape 再 decodeURIComponent
        const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
        const payload = JSON.parse(decodeURIComponent(escape(window.atob(base64))))
        this.adminName = payload.username || 'admin'
      }
    } catch (e) {
      console.error('解析 token 失败', e)
      this.adminName = 'admin'
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('admin_token')
      this.$router.push('/sys-gateway-x9')
    }
  }
}
</script>